module.exports = __webpack_public_path__ + "img/83.6d8765e8.jpg";